export enum XlsExportMode {
    withBanners = 'AD_GROUPS_WITH_ADS',
    withoutBanners = 'ONLY_AD_GROUPS'
}

export type XlsExportParams = Record<string, number[]>;
